import { useTranslation } from 'react-i18next';
import { DeviceType, Upload, Theme, ThemeId } from 'shared/models';
import { CommandLine } from './components/commandLine/CommandLine';
import { AddCommandLine } from './components/AddCommandLine';
import { CheckInLine } from './components/CheckInLine';
import { parse } from 'logic/deviceScriptParser';

require('./DeviceCommandsSection.css');

export type Props = {
    script: string | null;
    themes: Record<ThemeId, Theme>;
    uploads: Record<string, Upload>;
    deviceType: DeviceType | null;
    disableRemoteUpdates: boolean;
    onChangeScript(script: string): void;
};

export const DeviceCommandsSection = ({ script, themes, uploads, deviceType, disableRemoteUpdates, onChangeScript }: Props) => {
    const { t } = useTranslation();
    const deviceScript = parse(script, disableRemoteUpdates);
    return (
        <section id="device-commands-section">
            <header>
                <h2>{ t('DEVICE.COMMANDS.LINK') }</h2>
            </header>
            { deviceScript && deviceScript.commands.map((c, i) =>
                <CommandLine
                    key={ `${c.command}-${i}` }
                    index={ i }
                    command={ c }
                    themes={ themes }
                    uploads={ uploads }
                    deviceType={ deviceType }
                    canMoveUp={ i > 0 }
                    canMoveDown={ i < deviceScript.commands.length - 1 }
                    onClickUp={ () => onChangeScript(deviceScript.moveCommandUp(i).toString()) }
                    onClickDown={ () => onChangeScript(deviceScript.moveCommandDown(i).toString()) }
                    onClickDelete={ () => onChangeScript(deviceScript.removeCommandAt(i).toString()) }
                    onClickTheme={ themeId => onChangeScript(deviceScript.selectTheme(i, themeId).toString()) }
                    onClickSoftware={ filename => onChangeScript(deviceScript.selectSoftware(i, filename).toString()) }
                    onClickForce={ force => onChangeScript(deviceScript.forceSoftware(i, force).toString()) }
                    onChangeSetSetting={ setting => onChangeScript(deviceScript.setSetting(i, setting).toString()) }
                    onChangeSetValue={ value => onChangeScript(deviceScript.setValue(i, value).toString()) }
                    onChangeComment={ comment => onChangeScript(deviceScript.setComment(i, comment).toString()) }
                />
            ) }
            <AddCommandLine
                onClickAdd={ name => onChangeScript(deviceScript.addCommand(name).toString()) }
                remoteUpdatesDisabled={ disableRemoteUpdates }
            />
            <CheckInLine
                seconds={ deviceScript.checkin }
                onChangeSeconds={ seconds => onChangeScript(deviceScript.setCheckIn(seconds).toString()) }
            />
        </section>
    );
};
